import React from 'react';

import SvgIcon from '../core/SvgIcon';

const ValidateIcon = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props} fill="none">
    <path d="M16.125 9.75L10.6219 15L7.875 12.375" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ValidateIcon;
